import { ApiServices } from "../../services/api_services";
import { CALLURL } from "../../constants/api_constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateDispositionSuccess : any = createAsyncThunk("disposition/update_disposition", async (data: any) => {
  return ApiServices.put(CALLURL, `/update_disposition/${data.id}`, data)
    .then((response) => {
      console.log("update_disposition response", response)
      return response
    })
    .catch((error) => {
      console.log("update_disposition error", error)
    });
});
